<div
	class="modal fade"
	id="filtersModal"
	tabindex="-1"
	role="dialog"
	aria-labelledby="filtersModalLabel"
	aria-hidden="true"
>
	<div class="modal-dialog modal-dialog-scrollable">
		<div class="modal-content">
			<div class="modal-body">
				<div class="container">
					<div class="mb-3">
						<label for="transport" class="mt-3">Transport</label>
						<ng-select
							id="transport"
							name="transport"
							[(ngModel)]="filters.transport"
							[multiple]="false"
							[closeOnSelect]="false"
						>
							<ng-option *ngFor="let item of transport" [value]="item.enum">{{ item.name }}</ng-option>
						</ng-select>
					</div>
				</div>
			</div>
			<div class="modal-footer">
				<div class="row row-full">
					<div class="row">
						<div class="col-sm-7 text-start">
							<button type="button" class="btn btn-danger me-1" (click)="filtersClear()">Wyczyść</button>
							<button type="button" class="btn btn-success" (click)="filtersDefault()">Domyślne</button>
						</div>
						<div class="col-sm-5 text-end">
							<button type="button" class="btn btn-primary me-1" (click)="filtersSave()">Pokaż</button>
							<button
								type="button"
								class="btn btn-secondary"
								(click)="filtersClose()"
								data-bs-dismiss="modal"
							>
								Anuluj
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
